import { render, staticRenderFns } from "./edit-amendment-modal.vue?vue&type=template&id=54788c76&scoped=true&"
import script from "./edit-amendment-modal.vue?vue&type=script&lang=js&"
export * from "./edit-amendment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54788c76",
  null
  
)

export default component.exports